import { ShoppingBag } from "lucide-react";
import { useCart } from "@/context/CartContext";

const NAV_LINKS = [
  { href: "#scents", label: "The Scents" },
  { href: "#formula", label: "Formula" },
  { href: "#reviews", label: "Reviews" },
  { href: "#faq", label: "Details" },
];

export const Header = () => {
  const { count, setIsOpen } = useCart();

  return (
    <>
      {/* Announcement Bar */}
      <div
        data-testid="announcement-bar"
        className="border-b border-[var(--line)] bg-[var(--ink)] py-2 px-4 text-center label-caps text-[10px] text-[var(--bg)] flex items-center justify-center gap-3"
      >
        <span>Bare Essentials</span>
        <span className="opacity-40">&bull;</span>
        <span>Made in Canada</span>
        <span className="opacity-40">&bull;</span>
        <span>Secure Stripe Checkout</span>
      </div>

      {/* Nav */}
      <nav
        data-testid="main-nav"
        className="sticky top-0 z-50 border-b border-[var(--line)] bg-[var(--bg)]/95 backdrop-blur-md px-6 py-5 flex items-center justify-between"
      >
        <a href="#top" className="flex items-center gap-3" data-testid="brand-logo-link">
          <svg
            className="w-5 h-5 text-[var(--ink)]"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.25"
          >
            <circle cx="12" cy="12" r="9" />
            <path d="M12 3v18M3 12h18" />
            <circle cx="12" cy="12" r="2.5" fill="currentColor" />
          </svg>
          <div className="flex flex-col">
            <span className="label-caps text-sm tracking-[0.28em] font-medium text-[var(--ink)]">
              BARE ESSENTIALS
            </span>
            <span className="text-[9px] uppercase tracking-[0.2em] text-[var(--ink)]/60">
              Skincare Refined
            </span>
          </div>
        </a>

        <div className="hidden md:flex items-center gap-10 label-caps text-[11px] text-[var(--ink)]/80">
          {NAV_LINKS.map((link) => (
            <a
              key={link.href}
              href={link.href}
              data-testid={`nav-link-${link.label.toLowerCase().replace(/\s+/g, "-")}`}
              className="hover:text-[var(--ink)] transition-colors"
            >
              {link.label}
            </a>
          ))}
        </div>

        <div className="flex items-center gap-3">
          <a
            href="#scents"
            data-testid="nav-order-cta"
            className="hidden sm:inline-block border border-[var(--ink)] px-5 py-2 label-caps text-[10px] text-[var(--ink)] hover:bg-[var(--ink)] hover:text-[var(--bg)] transition-colors"
          >
            Acquire &bull; $68
          </a>
          <button
            type="button"
            data-testid="cart-open-button"
            onClick={() => setIsOpen(true)}
            className="relative border border-[var(--ink)] p-2 text-[var(--ink)] hover:bg-[var(--ink)] hover:text-[var(--bg)] transition-colors"
            aria-label="Open cart"
          >
            <ShoppingBag className="w-4 h-4" strokeWidth={1.5} />
            {count > 0 && (
              <span
                data-testid="cart-count-badge"
                className="absolute -top-2 -right-2 bg-[var(--ink)] text-[var(--bg)] text-[9px] mono-num w-4 h-4 flex items-center justify-center rounded-full"
              >
                {count}
              </span>
            )}
          </button>
        </div>
      </nav>
    </>
  );
};
